/* eslint-disable no-shadow */
enum DataStorageUnit {
  B = 'B', // Bytes
  KB = 'KB', // Kilobytes
  MB = 'MB', // Megabytes
  GB = 'GB', // Gigabytes
  TB = 'TB', // Terabytes
  PB = 'PB', // Petabytes
  EB = 'EB', // Exabytes
  ZB = 'ZB', // Zettabytes
  YB = 'YB', // Yottabytes
}

export default DataStorageUnit;
